import { Check, DirectionsCarFilledOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';

type RefuelTargetTabIconProps = {
  isSelected: boolean;
};

export function RefuelTargetTabIcon({ isSelected }: RefuelTargetTabIconProps) {
  return (
    <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <DirectionsCarFilledOutlined />
      {isSelected && (
        <Check
          color="success"
          fontSize="medium"
          sx={{
            position: 'absolute',
            // The checkmark aligns with the fixed-size vehicle icon, so this offset must remain pixel exact.
            right: '-25px',
          }}
        />
      )}
    </Box>
  );
}
